module.exports = __webpack_public_path__ + "static/img/02img.488b13e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/01challengeList/02img.png
// module id = KFlk
// module chunks = 0